<template>
<div class="plain" :class="{'active':FPPlainList.length>0}">
  <div class="plain--header">
    <div class="plain--header--title">
      <div class="title--left iconfont" @click="$router.push('/')">&#xe600;</div>
      <div class="title--text">下一步计划</div>
      <div class="title--tel iconfont" @click="$router.push('/addplain')">&#xe602;</div>
    </div>
    <div class="plain--header--item">
      <div
        class="item--left"
        :class="{active:PlainHeaderFlag ==='notfinish'}"
        @click="handleToChangePlainList('notfinish')"
      >
        待跟进计划<span>{{notFinishNum}}</span>
      </div>
      <div
        class="item--center"
        :class="{active:PlainHeaderFlag ==='finished'}"
        @click="handleToChangePlainList('finished')"
      >
        已跟进计划<span>{{finishedNum}}</span>
      </div>
    </div>
  </div>
  <div class="plain--line"></div>
  <div class="plain--info" v-if="FPPlainList.length>0">
    <div
      class="plain--info--item"
      v-for="item in FPPlainList"
      :key="item.id"
    >
      <div class="item--title">{{item.cusName}}</div>
      <div class="item--content">
        <div class="item--content--info">
          <div class="info--time">计划日期:<span>{{item.planTime}}</span></div>
          <div class="info--person">提醒人:<span>{{item.actornames}}</span></div>
        </div>
        <div class="item--content--icon iconfont" v-if="false">&#xe7b5;</div>
      </div>
      <div class="item--text">{{item.remark}}</div>
      <div class="item--func" v-if="couldEdit">
        <div class="func--cancle" @click="handleToDelFollowPlain(item.id)">删除</div>
        <div class="func--modify" @click="handleToModifyFollowPlain(item)">修改</div>
        <div class="func--record" @click="handleToPlainRecord(item)">填写营销日志</div>
      </div>
      <div class="item--func" v-else>
        <div class="func--record" @click="handleToPlainRecord(item)">查看营销日志</div>
      </div>
    </div>
  </div>
  <div class="plain--info" v-else>
    <van-empty description="暂无数据" />
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { get, post } from '../api/api'
import recordPageTime from '../mixin/minin'
export default {
  name: 'plain',
  data () {
    return {
      finishedNum: 0, // 已跟进计划总数
      notFinishNum: 0, // 待跟进计划总数
      pageNum: 1, // 获取跟进计划列表从那一条开始
      pageSize: 10, // 获取跟进计划列表一共多少条
      FPPlainList: [], // 跟进计划列表
      PlainTotal: '', // 待跟进计划列表总数
      PlainHeaderFlag: 'notfinish',
      scrollNum: 50, // 滑动到底部提前控制触发的数值
      scrollPlainFlag: true, // 控制滑动pageNum在没有返回值的时候不能加1
      couldEdit: ''
    }
  },
  beforeMount () {
    this.getFollowPlainnotFinishList()
  },
  mounted () {
    // const plainContentElement = document.body
    window.addEventListener('scroll', this.handleToPlainListScroll, true)
  },
  destroyed () {
    // const plainContentElement = document.body
    window.removeEventListener('scroll', this.handleToPlainListScroll, true)
  },
  methods: {
    // 获取待跟进计划列表
    async getFollowPlainnotFinishList () {
      const result = await get('/api/CBMS-APP/mmFollowPlan/list', {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        this.FPPlainList = this.FPPlainList.concat(result.data.mmFollowPlanIPage.records)
        this.notFinishNum = result.data.notFinishNum
        this.finishedNum = result.data.finishedNum
        this.PlainTotal = result.data.mmFollowPlanIPage.total
      } else {
        this.$toast.success('获取数据报错')
      }
    },
    // 获取已跟进计划列表
    async getFollowPlainFinishList () {
      const result = await get('/api/CBMS-APP/mmFollowPlan/listfinish', {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        this.FPPlainList = this.FPPlainList.concat(result.data.records)
        this.PlainTotal = result.data.total
      } else {
        this.$toast.success('获取数据报错')
      }
    },
    // 更改跟进计划列表数据
    handleToChangePlainList (val) {
      this.pageNum = 1
      this.PlainHeaderFlag = val
      this.FPPlainList = []
      this.PlainTotal = ''
      if (val === 'notfinish') {
        this.getFollowPlainnotFinishList()
      } else if (val === 'finished') {
        this.getFollowPlainFinishList()
      }
    },
    // 删除跟进计划
    async handleToDelFollowPlain (id) {
      const _this = this
      this.$dialog.confirm({
        title: _this.cusName,
        message: '确认删除跟进计划'
      })
        .then(async () => {
          const result = await post('/api/CBMS-APP/mmFollowPlan/remove', { id })
          if (result.success) {
            this.$toast.success({
              message: '已删除',
              onClose: () => {
                this.FPPlainList = this.FPPlainList.filter(item => item.id !== id)
                this.notFinishNum = Number(this.notFinishNum) - 1
              }
            })
          }
        })
        .catch(() => {
          this.$toast.success('已取消')
        })
    },
    // 修改跟进计划
    handleToModifyFollowPlain (item) {
      this.$router.push({ name: 'addplain', params: { item } })
    },
    // 带着cusName、certCode、relMatterId到'/addfollowup'
    handleToPlainRecord (item) {
      this.$router.push({ name: 'addfollowup', params: { id: item.relMatterId, certCode: item.certCode, cusName: item.cusName } })
    },
    // 滑动加载更多数据
    async handleToPlainListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        if (this.FPPlainList.length < this.PlainTotal && this.PlainHeaderFlag === 'notfinish' && this.scrollPlainFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollPlainFlag = false
          const result = await get('/api/CBMS-APP/mmFollowPlan/list', {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          })
          if (result.success) {
            this.scrollPlainFlag = true
            this.FPPlainList = this.FPPlainList.concat(result.data.mmFollowPlanIPage.records)
            this.PlainTotal = result.data.mmFollowPlanIPage.total
          } else {
            this.$toast.success('获取数据报错')
          }
        } else if (this.FPPlainList.length < this.PlainTotal && this.PlainHeaderFlag === 'finished' && this.scrollPlainFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollPlainFlag = false
          const result = await get('/api/CBMS-APP/mmFollowPlan/listfinish', {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          })
          if (result.success) {
            this.scrollPlainFlag = true
            this.FPPlainList = this.FPPlainList.concat(result.data.records)
            this.PlainTotal = result.data.total
          } else {
            this.$toast.success('获取数据报错')
          }
        } else if (this.FPPlainList.length === this.PlainTotal) {
          this.scrollNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.plain
  position : relative
  width : 100vw
  height : 100vh
  background-color : #f7f7f7
  overflow-x : hidden
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .plain--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .plain--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--left
        font-size : 48px
        width : 80px
        padding-left : 16px
        text-align : left
        color : #ffffff
      .title--tel
        font-size : 48px
        width : 80px
        padding-right : 16px
        text-align : right
        a
          color : #ffffff
      .title--text
        flex : 1
        text-align : center
    .plain--header--item
      display : flex
      background-color : #f7f7f7
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      color: #333333
      border-bottom : 1px solid #b6b5b5
      .item--left
        flex : 1
        text-align : center
        padding : 16px 0
        &.active
          border-bottom : 5px solid #7186d3
        span
          padding : 4px 16px
          margin-left : 8px
          background-color : #7186d3
          color: #ffffff
          border-radius : 12px
      .item--center
        flex : 1
        text-align : center
        padding : 16px 0
        border-left : 1px solid #b6b5b5
        &.active
          border-bottom : 5px solid #7186d3
        span
          padding : 4px 16px
          margin-left : 8px
          background-color : #7186d3
          color: #ffffff
          border-radius : 12px
  .plain--line
    width : 100%
    height:150px
  .plain--info
    .plain--info--item
      margin : 16px 16px 0 16px
      padding : 16px
      background-color : #ffffff
      border-radius : 12px
      border : 1px solid #b6b5b5
      font-size : 28px
      .item--title
        padding : 16px
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
      .item--content
        display : flex
        justify-content : center
        align-items : center
        padding : 16px
        .item--content--icon
          padding: 16px
          font-size : 48px
          font-weight: normal
          font-stretch: normal
          color : #7186d3
        .item--content--info
          flex : 1
          font-size: 28px
          font-weight: normal
          font-stretch: normal
          color: #333333
          .info--time
            padding-bottom : 8px
            span
              padding-left : 16px
          .info--person
            padding-top : 8px
            span
              padding-left : 16px
      .item--text
        padding : 16px
        line-height : 1.5
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
      .item--func
        display : flex
        padding : 16px
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .func--cancle
          flex : 1
          padding : 8px 0
          text-align : center
        .func--modify
          flex : 1
          padding : 8px 0
          text-align : center
          border-right : 1px solid #b6b5b5
          border-left : 1px solid #b6b5b5
        .func--record
          flex : 2
          padding : 8px 0
          text-align : center
</style>
